import { Skeleton, Table } from 'antd'
import { Suspense, useEffect } from 'react'
import useSWR from 'swr'

import { fetchDetail } from '../../../api'
import { sortDateColumn } from '../../../components/tables/utils'

const columns = [
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    key: 'startDate',
    sorter: sortDateColumn({ dataIndex: 'startDate' }),
  },
  {
    title: 'Short Rating',
    dataIndex: 'short',
    key: 'short',
  },
  {
    title: 'Long Rating',
    dataIndex: 'long',
    key: 'long',
  },
]

export const IsinRatingHistory = ({ isin, shouldRefreshRatings, onSuccess }) => {
  const { data: isinDetails, mutate } = useSWR(isin ? `/isins/${isin}` : null, fetchDetail, { suspense: true })

  useEffect(() => {
    if (shouldRefreshRatings) {
      mutate()
      onSuccess()
    }
  }, [shouldRefreshRatings, onSuccess, mutate])

  return (
    <Suspense fallback={<Skeleton />}>
      <Table
        dataSource={isinDetails?.ratings}
        loading={!isinDetails}
        columns={columns}
        pagination={{ pageSize: 5 }}
        rowKey="isin"
        size="small"
      />
    </Suspense>
  )
}
